/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileHide = (props: Props) => (
  <Icon viewBox="0 0 24 25" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M15.347 15.433A5.626 5.626 0 0 1 17.5 15c2.153 0 4.236 1.236 5.394 3.553l.224.447-.223.447a6.851 6.851 0 0 1-1.515 2.019l1.827 1.827-1.414 1.414-2.14-2.14A5.625 5.625 0 0 1 17.5 23c-2.153 0-4.236-1.236-5.394-3.553L11.881 19l.223-.447a6.855 6.855 0 0 1 1.514-2.02l-1.826-1.826 1.414-1.414zm-.314 2.514A4.624 4.624 0 0 0 14.145 19c.855 1.372 2.134 2 3.355 2 .18 0 .361-.016.542-.044l-.72-.72a1.248 1.248 0 0 1-1.058-1.058zM17.5 17c-.18 0-.362.015-.543.043l.72.72c.548.079.98.51 1.058 1.058l1.23 1.23c.328-.283.63-.632.89-1.051-.855-1.372-2.134-2-3.355-2z" />
        <path d="M14.414 2 20 7.586V13h-2V9h-5V4H6v16h4v2H4V2zM15 7h1.586L15 5.414z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileHide as FileHide };
